import { render, staticRenderFns } from "./ModalPlain.vue?vue&type=template&id=205d2b27&scoped=true"
var script = {}
import style0 from "./ModalPlain.vue?vue&type=style&index=0&id=205d2b27&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205d2b27",
  null
  
)

export default component.exports